import { Tabs, ScrollArea } from '@mantine/core';

import { statsPeriodList, statsPeriodTitles } from '../utils/const/common';

import type { TStatsPeriod } from '../store/types';

type Props = {
  value: TStatsPeriod | null;
  onChange: (period: TStatsPeriod) => void;
};

export const StatsPeriod = (props: Props) => {
  const { value, onChange } = props;

  return (
    <Tabs value={value} onChange={(period) => period && onChange(period as TStatsPeriod)}>
      <ScrollArea scrollbarSize={2} scrollbars="x">
        <Tabs.List mb={10} style={{ flexWrap: 'nowrap' }}>
          {statsPeriodList.map((period) => (
            <Tabs.Tab key={period} value={period}>
              {statsPeriodTitles[period]}
            </Tabs.Tab>
          ))}
        </Tabs.List>
      </ScrollArea>
    </Tabs>
  );
};
